//
// localise.js - localisation function
//

// localise()
// -----------------------
// opts:
//     suppress_errors   bool    default: false
//     strings           array   default: the value of window.__localisations
//

import {country_code} from './site-lang';

const l = window.__localisations || {};
const cc = country_code();

function err(str, opts) {
  return opts.suppress_errors ? null : `localise.js error: string '${str}' not found`;
}

export default function localise(str, opts) {
  opts = opts || { };
  opts.suppress_errors = !!opts.suppress_errors;
  const strings = opts.strings || l;

  if (!strings[str]) {
    return err(str, opts);
  }

  const s = strings[str];

  if (s.constructor === String) {
    return s;
  }
  if (s[cc]) {
    return s[cc];
  }

  return err(str, opts);
}

